/**
 * Central Test Theme definition
 *
 * @format
 * @See the Central Test QDS 15042022-QDS-Round2 for details
 */
import colors from "../css/settings/colors.module.scss";
const {
    greyLighten5, greyLighten3, greyDarken2, greyDarken3, greyDarken4, greyDarken5,
    white,
    deepPurple,
    cyan,
    red,
    blue,
    green,
    orange,
    black,
    extraBlack,
    blueGreyLighten5, deepPurpleDarken2
} = colors;

export const ctThemeLight = {
    dark: false,
    colors: {
        background: greyLighten5,
        surface: white,
        "surface-variant": greyLighten3,
        "on-surface-variant": greyLighten3,
        primary: deepPurple,
        secondary: cyan,
        error: red,
        info: blue,
        success: green,
        warning: orange,
        "on-surface": greyDarken3,
        "on-background": greyDarken3,
        dark: black,
        border: greyLighten3,
        "grey-darken": greyDarken2,
        "extra-black": extraBlack,
        "surface-icon": blueGreyLighten5,
        "grey-darken-5": greyDarken5
    },
    variables: {
        "border-color": greyLighten3,
        "border-opacity": 0.9,
        "high-emphasis-opacity": 1,
        "medium-emphasis-opacity": 0.6,
        "disabled-opacity": 0.38,
        "idle-opacity": 0.04,
        "hover-opacity": 0.04,
        "focus-opacity": 0.18,
        "selected-opacity": 0.08,
        "activated-opacity": 0.18,
        "pressed-opacity": 0.18,
        "dragged-opacity": 0.08
    },
}

export const ctThemeDark = {
    dark: true,
    colors: {
        background: greyDarken4,
        surface: greyDarken3,
        "surface-variant": greyLighten5,
        "on-surface-variant": greyDarken2,
        primary: cyan,
        secondary: deepPurple,
        error: red,
        info: blue,
        success: green,
        warning: orange,
        "on-surface": greyLighten5,
        "on-background": greyLighten5,
        dark: greyLighten5,
        border: greyDarken3,
        "grey-darken": white,
        "extra-black": white,
        "surface-icon": deepPurpleDarken2,
        "grey-darken-5": white
    },
    variables: {
        "border-color": greyDarken3,
        "border-opacity": 0.9,
        "high-emphasis-opacity": 1,
        "medium-emphasis-opacity": 0.6,
        "disabled-opacity": 0.38,
        "idle-opacity": 0.04,
        "hover-opacity": 0.04,
        "focus-opacity": 0.18,
        "selected-opacity": 0.08,
        "activated-opacity": 0.18,
        "pressed-opacity": 0.18,
        "dragged-opacity": 0.08
    },
}
